module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link) ? _c('module-link', {
    staticClass: "logo logo--link",
    attrs: {
      "link": _vm.link,
      "no-underline": true
    }
  }, [_c('span', {
    staticClass: "h3 mt0 mb0"
  }, [_c('span', {
    staticClass: "logo__part logo__part--first"
  }, [_vm._v("Rob")]), _vm._v(" "), _c('span', {
    staticClass: "logo__part logo__part--last"
  }, [_vm._v("Sterlini-Aitchison")])])]) : _c('span', {
    staticClass: "logo h3"
  }, [_vm._v("\n  Rob Sterlini-Aitchison\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478305f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Logo.vue
// module id = 25
// module chunks = 1